import _ from 'lodash'

const state = {
    deliveryCompaniesList: []
}
const getters = {
    getDeliveryCompaniesList(state) {
        return state.deliveryCompaniesList
    },

    getDeliveryCompanyById(state) {
        return (id) => state.deliveryCompaniesList.find(deliveryCompany => deliveryCompany.value == id)
    }
}
const mutations = {
    SET_DELIVERY_COMPANIES_LIST(state, newDeliveryCompaniesList) {
        state.deliveryCompaniesList = newDeliveryCompaniesList
    }
}
const actions = {
    setDeliveryCompaniesList(context, newDeliveryCompaniesList) {
        console.log(newDeliveryCompaniesList)
        const newDeliveryCompaniesListMapped = newDeliveryCompaniesList.map(deliveryCompany => {
            return { value: deliveryCompany.id, text: deliveryCompany.name }
        })
        context.commit('SET_DELIVERY_COMPANIES_LIST', newDeliveryCompaniesListMapped)
    }
}

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}